import { useContext, useEffect, useState } from "react";
import { ContextProviderWrapper } from "../../../../components/Context";
import {
  BackToButton,
  LiquidityDetailsContainer,
  LiquidityDetailsWrapper,
  TitleBox,
} from "../Details/styled";
import { LiquidityBg } from "../Add/styled";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import arrow from "../../../../assets/Dashboard/Common/arrow_gray.svg";
import {
  BlockChart,
  BlockLeft,
  BlockReward,
  BlockRight,
  ContentsReward,
  FooterChart,
  FooterChartItem,
  MainWrapper,
  PairTokens,
  RowContents,
  ShowChart,
  TextNoDataLiquidity,
  TitleChart,
} from "./styled";
import Chart from "react-apexcharts";
import { ButtonCommon } from "../../../../Layout/styled";
import { useAppKitAccount } from "@reown/appkit/react";
import { convertFixed } from "../../../../utils/convertNumber";
import axios from "axios";
import ModalOverlay from "../../../../components/Common/ModalOverlay";
import SettingSwapLiquidity from "./Slippage";
import RemoveLiquidity from "./Remove";
import AddLiquidity from "./Add";
import TabsSelector from "../../Farm/TabsSelector";

export default function DetailV2() {
  const contractAddress = "0x18556DA13313f3532c54711497A8FedAC273220E";
  const { theme } = useContext(ContextProviderWrapper)!;
  const navigate = useNavigate();
  const { address } = useAppKitAccount();
  const { id } = useParams();
  const { search } = useLocation();
  const [dataLiquidity, setDataLiquidity] = useState<any>(null);
  const [datasChart, setDataChart] = useState<any>({
    series: [
      {
        name: "AVAX",
        data: [44, 55, 41, 67, 22, 43],
      },
      {
        name: "USDT",
        data: [13, 23, 20, 8, 13, 27],
      },
    ],
    options: {
      chart: {
        stacked: true,
      },
      toolbar: {
        show: false,
        enabled: false,
      },
      colors: ["#ee464a", "#4bb26c"],
      responsive: [
        {
          breakpoint: 480,
        },
      ],
      dataLabels: {
        enabled: false,
        enabledOnSeries: [1],
      },
      xaxis: {
        type: "datetime",
        show: false,
        categories: [
          "01/01/2011 GMT",
          "01/02/2011 GMT",
          "01/03/2011 GMT",
          "01/04/2011 GMT",
          "01/05/2011 GMT",
          "01/06/2011 GMT",
        ],
      },
      grid: {
        yaxis: {
          lines: {
            show: false,
          },
        },
      },
      yaxis: {
        show: false,
      },
      tooltip: {
        enabled: false,
      },
      fill: {
        opacity: 1,
      },
    },
  });
  const [slippageTolerance, setSlippageTolerance] = useState(0.5);
  const [openSlippage, setOpenSlippage] = useState(false);
  const [tab, setTab] = useState(1);
  const [binActive, setBinActive] = useState<any>({});
  const [poolDetail, setPoolDetails] = useState<any>({});

  const handleGetDataChart = async () => {
    try {
      if (!address) return;
      const ver = search.split("=");
      const { data } = await axios.get(
        `https://ap-dev-kibble.netlify.app/api/poolUserBalance?wallet=${address}&pool=${id}&v=${ver[1]}`
      );
      const dataChart = {
        series: [
          {
            name: data.X_Symbol,
            data: data.data_Chart.yaxis.x_val,
          },
          {
            name: data.Y_Symbol,
            data: data.data_Chart.yaxis.y_val,
          },
        ],
        options: {
          ...datasChart.options,
          xaxis: {
            show: false,
            categories: data.data_Chart.xaxis,
          },
        },
      };
      setDataChart(dataChart);
      setDataLiquidity(data);
    } catch (error) {
      console.log("handleGetDataChart err", error);
    }
  };

  useEffect(() => {
    handleGetDataChart();
  }, [address, id]);

  const handleGetPoolDetails = async () => {
    try {
      const res = await axios.get(
        `https://ap-dev-kibble.netlify.app/pools/detail/${id}`
      );
      if (res) {
        setPoolDetails(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetPoolDetails();
  }, [id]);

  const handleSwitchTabs = () => {
    switch (tab) {
      case 1:
        return (
          <AddLiquidity
            slippageTolerance={slippageTolerance}
            setOpenSlippage={setOpenSlippage}
            poolDetail={poolDetail}
            contractAddress={contractAddress}
            setBinActive={setBinActive}
            binActive={binActive}
          />
        );
      case 2:
        return (
          <RemoveLiquidity
            datasChart={datasChart}
            dataLiquidity={dataLiquidity}
            poolDetail={poolDetail}
            slippageTolerance={slippageTolerance}
            handleGetDataChart={handleGetDataChart}
            binActive={binActive}
          />
        );
      default:
        break;
    }
  };

  const TABS = [
    {
      title: "Add Liquidity",
      value: 1,
    },
    {
      title: "Remove Liquidity",
      value: 2,
    },
  ];

  return (
    <>
      <ModalOverlay
        component={
          <SettingSwapLiquidity
            slippageTolerance={slippageTolerance}
            setSlippageTolerance={setSlippageTolerance}
            setOpenSlippage={setOpenSlippage}
          />
        }
        open={openSlippage}
        setOpen={setOpenSlippage}
        title={"Slippage"}
        width="400px"
      />
      <LiquidityDetailsContainer>
        <LiquidityBg className={theme}>
          <LiquidityDetailsWrapper className={theme}>
            <BackToButton
              onClick={() => {
                navigate(-1);
              }}
            >
              <img src={arrow} alt="icon" />
              <p>Back to pools</p>
            </BackToButton>
            <TitleBox>
              <h1>liquidity pool</h1>
              <p>Earn rewards by providing liquidity</p>
            </TitleBox>
            <MainWrapper className="row-between">
              <BlockLeft className={`${theme} row-center`}>
                <BlockChart>
                  <TitleChart className="row-between">
                    <h1>My Liquidity</h1>
                    <PairTokens className="row-right">
                      <div className="row-right">
                        <div
                          style={{
                            background: "#ee464a",
                          }}
                          className="dot"
                        ></div>
                        <p>{dataLiquidity?.X_Symbol}</p>
                      </div>
                      <div className="row-right">
                        <div
                          style={{
                            background: "#4bb26c",
                          }}
                          className="dot"
                        ></div>
                        <p>{dataLiquidity?.Y_Symbol}</p>
                      </div>
                    </PairTokens>
                  </TitleChart>
                  <ShowChart>
                    {!dataLiquidity ? (
                      <TextNoDataLiquidity>
                        You have no liquidity in this pool
                      </TextNoDataLiquidity>
                    ) : (
                      <>
                        <Chart
                          options={datasChart.options}
                          series={datasChart.series}
                          height={350}
                          type="bar"
                        />
                      </>
                    )}
                  </ShowChart>
                  <FooterChart>
                    <h2>Deposit Balance</h2>
                    <div className="row-left">
                      <FooterChartItem className="row-left">
                        <div>
                          <h3>{dataLiquidity?.X_Symbol}</h3>
                          <p>
                            $
                            {convertFixed(
                              Number(dataLiquidity?.userBlX) /
                                10 ** Number(dataLiquidity?.X_Decimals)
                            )}
                          </p>
                        </div>
                      </FooterChartItem>
                      <h1>+</h1>
                      <FooterChartItem className="row-left">
                        <div>
                          <h3>{dataLiquidity?.Y_Symbol}</h3>
                          <p>
                            $
                            {convertFixed(
                              Number(dataLiquidity?.userBlY) /
                                10 ** Number(dataLiquidity?.Y_Decimals)
                            )}
                          </p>
                        </div>
                      </FooterChartItem>
                    </div>
                  </FooterChart>
                </BlockChart>
                <BlockReward>
                  <TitleChart
                    style={{
                      padding: 0,
                    }}
                    className="row-between"
                  >
                    <div>
                      <h1>Rewards</h1>
                      <p>
                        Earn rewards for providing liquidity within specified
                        price range.
                      </p>
                    </div>
                  </TitleChart>
                  <ContentsReward>
                    <RowContents className="row-between">
                      <p>Token</p>
                      <div className="row-right">
                        <div className="img-token row-center">
                          <img src="/static/AvaxLogo.png" alt="img" />
                        </div>
                        <h1>AVAX</h1>
                      </div>
                    </RowContents>
                    <RowContents className="row-between">
                      <p>Rewards per day:</p>
                      <div className="row-right">
                        <h1>100 AVAX</h1>
                      </div>
                    </RowContents>
                    <RowContents className="row-between">
                      <p>Reward range:</p>
                      <div className="row-right">
                        <h1>+/- 0% (1 bin)</h1>
                      </div>
                    </RowContents>
                    <RowContents className="row-between">
                      <p>Current range:</p>
                      <div className="row-right">
                        <h1>18.47 - 18.47 USDC per AVAX</h1>
                      </div>
                    </RowContents>
                    <RowContents className="row-between">
                      <p>Range TVL:</p>
                      <div className="row-right">
                        <h1>$8,602.33</h1>
                      </div>
                    </RowContents>
                    <RowContents className="row-between">
                      <p>Rewards APR:</p>
                      <div className="row-right">
                        <h1>7841.79%</h1>
                      </div>
                    </RowContents>
                    <RowContents className="row-between">
                      <p>Time remaining:</p>
                      <div className="row-right">
                        <h1>N/A</h1>
                      </div>
                    </RowContents>
                  </ContentsReward>
                  <TitleChart
                    style={{
                      paddingLeft: 0,
                      paddingBottom: 0,
                      marginTop: "20px",
                    }}
                    className="row-between"
                  >
                    <h1>Claimable Rewards</h1>
                    <PairTokens className="row-right">
                      <div className="row-right">
                        <p>
                          Balance: <span>0.00</span>
                        </p>
                      </div>
                    </PairTokens>
                  </TitleChart>
                  <FooterChartItem
                    className="row-left"
                    style={{
                      marginRight: 0,
                    }}
                  >
                    <div className="img-token">
                      <img src="/static/AvaxLogo.png" alt="img" />
                    </div>
                    <div>
                      <h3>AVAX</h3>
                      <p>$0</p>
                    </div>
                  </FooterChartItem>
                  <ButtonCommon>Claim</ButtonCommon>
                </BlockReward>
              </BlockLeft>
              <BlockRight className={theme}>
                <TabsSelector
                  data={[...TABS]}
                  callBack={(data: any) => {
                    setTab(data.value);
                  }}
                  active={tab}
                />
                {handleSwitchTabs()}
              </BlockRight>
            </MainWrapper>
          </LiquidityDetailsWrapper>
        </LiquidityBg>
      </LiquidityDetailsContainer>
    </>
  );
}
